export const colors = [
  'black',
  'black-lighter',
  'blue',
  'blue-dark',
  'blue-darker',
  'blue-light',
  'blue-lighter',
  'blue-lightest',
  'border-color',
  'gray',
  'gray-dark',
  'gray-darker',
  'gray-light',
  'gray-lighter',
  'green',
  'green-light',
  'green-lighter',
  'green-whatsapp',
  'helper-darken',
  'helper-darken-plus',
  'orange',
  'orange-dark',
  'orange-darker',
  'orange-light',
  'orange-lighter',
  'purple',
  'purple-light',
  'purple-lighter',
  'red',
  'red-lighter',
  'white',
  'yellow',
  'yellow-light',
  'yellow-lighter',
] as const;

export type Color = typeof colors[number];

export const getColorValue = (color: Color): string => COLOR_VALUES[color] || '';
